import { Navigation, Swiper, A11y } from 'swiper';

export default class skanegySliders {
	constructor() {
		this.init();
	}

	/**
	 * Init the class functionality.
	 */
	init() {
		this.initSchoolSwiper();
	}

	/**
	 * Init Swiper!
	 */
	initSchoolSwiper() {
		if ( ! document.querySelector( '.school__gallery .swiper' ) ) {
			return;
		}
		// Set up swiper.
		new Swiper(
			'.school__gallery .swiper',
			{
				modules: [ Navigation, A11y ],
				direction: 'horizontal',
				slidesPerView: 'auto',
				loop: true,
				autoHeight: true,
				watchSlidesProgress: true,
				navigation: {
					nextEl: '.slider-arrow--next',
					prevEl: '.slider-arrow--prev',
					closest: '.school_gallery',
				},
			},
		);
	}
}
